import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

// utils
import { isCpomsEnabled, isServiceAdmin } from '../../../utils/permissions';
import { capitalize } from '../../../utils/text';

// Services
import LocalStorageService from '../../../services/LocalStorageService'
import FormService from '../../../services/FormService'
import ReportService from '../../../services/ReportService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'
import DataTable from '../../../components/simple/dataTable/DataTable.js';
import Text from '../../../components/simple/text/Text'
import Anchor from '../../../components/simple/anchor/Anchor.js';
import ActionButton from '../../../components/compound/actionButton/ActionButton.js';


// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import moment from 'moment'
import PulseLoader from 'react-spinners/PulseLoader.js'

function Incidents (props) {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [sort, setSort] = useState({
      property: 'reference',
      direction: 'desc'
    })

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const terms = LocalStorageService.get('terms')
    const params = useParams()
    const userId = params.userid

    let suTerm = capitalize(terms?.serviceUser || 'Service User')

    const goBack = () => {
        navigate(-1)
    }     

    useEffect(() => {
        (async () => {
            if (!userId) { return }
            
            
            await getData()
            
    
            // setClickerValues(previousValues => ({
            // ...previousValues,
            // student: userId
            // }))

        })()
    }, [userId])

    const getData = async () => {
      setLoading(true)
      let searchType = 'incidentSearch'
      if (isServiceAdmin()) {
        searchType = 'globalIncidentSearch'
      }

      const results = await ReportService.getReport(
        apiToken,
        { 
          orgId: activeOrg.id,
          // limit: 100,
          // page: 1
        },
        {
          submissionType: 'incidentReport',
          query: [
            {
            "key": "completedBy",
              "operator": "is",
              "response": userId,
              "relation": null
            }
          ],
          reports: [
            searchType
          ],
        },
      )

      if (results?.incidentSearch) {
        setData(results.incidentSearch)
      }
      setLoading(false)
    }



      const deleteReport = async submissionId => {
        if (window.confirm('Are you sure you want to delete this?')) {
          await FormService.updateSubmission(apiToken, submissionId, {
            status: 'Archived',
          });
          getData()
        }
      };
    
      const pushIncidentToCpoms = async submissionId => {
    
        if (!isCpomsEnabled()) {
          return alert('CPOMS is not enabled for this organisation');
        }
    
        if (window.confirm('Are you sure you want to push this incident to CPOMS?')) {
          const response = await FormService.pushIncidentToCpoms(apiToken, submissionId);
          if (response?.error) {
            alert('There was an error pushing to CPOMS: ' + response.error);
          } else {
            alert('Successfully pushed to CPOMS');
            window.location.reload(); // this is not ideal
          }
        }
      }


  
  const resultColumns = []
  resultColumns.push({
      property: 'reference',
      header: <Text pad='none' margin='none' color='secondary' weight='800'>Incident No</Text>,
      render: datum => (
        
        <Text>
          {datum.pdfUrl && (
            <Anchor href={"/pdfviewer?url=" + encodeURIComponent(datum.pdfUrl)} color="primary">
              {datum.id ? `besmart-${datum.reference}` : ''}
            </Anchor>
          )}
          {!datum.pdfUrl && (
            `${datum.id ? `besmart-${datum.reference}` : ''}`
          )}
        </Text>
      ),
    });

    resultColumns.push({
      property: 'dateOfIncident',
      header: <Text pad='none' margin='none' color='secondary' weight='800'>Date Of Incident</Text>,
      render: datum => (
        <Text>
          {moment(datum.dateOfIncident).format('DD/MM/YY') === 'Invalid date'
            ? 'No Date'
            : moment(datum.dateOfIncident).format('DD/MM/YY')}
        </Text>
      ),
    })
    resultColumns.push({
      property: 'parentsInformed',
      header: <Text pad='none' margin='none' color='secondary' weight='800'>Parents Informed</Text>,
      render: datum => {
        const setParentsInformed = async value => {
          await FormService.updateSubmission(apiToken, datum.id, {
            parentsInformed: value,
          });

          document.getElementById(
            `parentsinformed-${datum.id}-${value === 'no' ? 'yes' : 'no'}`,
          ).style.opacity = 0.15;

          document.getElementById(
            `parentsinformed-${datum.id}-${value}`,
          ).style.opacity = 1;
        };

        return (
          <Box direction="row" width="100%">
            <ActionButton plain onClick={() => setParentsInformed('no')}>
              <FontAwesomeIcon
                id={`parentsinformed-${datum.id}-no`}
                className={`parentsinformed-${datum.id}`}
                icon={['fa', 'thumbs-down']}
                color="#777"
                style={
                  !['yes'].includes(datum.parentsInformed)
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
            <ActionButton plain onClick={() => setParentsInformed('yes')}>
              <FontAwesomeIcon
                id={`parentsinformed-${datum.id}-yes`}
                className={`parentsinformed-${datum.id}`}
                icon={['fa', 'thumbs-up']}
                color="#00FF00"
                style={
                  'yes' === datum.parentsInformed
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
          </Box>
        );
      },
    })

    if (isCpomsEnabled()) {
      resultColumns.push({
        property: 'cpomsId',
        header: <Text pad='none' margin='none' color='secondary' weight='800'>CPOMS</Text>,
        render: datum => {
        
          const isFailed = datum.cpomsSyncFailed == 1 ? true : false
          const isSynced = datum.cpomsId && datum.cpomsId !== null && datum.cpomsSyncFailed != 1 ? true : false
          const isEligibleToSync = !activeOrg?.cpomsSyncEverything && (!datum.cpomsId || datum.cpomsId === null) && datum.userCpomsId && datum.cpomsSyncFailed != 1 ? true : false
          const unableToSync = !isFailed && !isSynced && !isEligibleToSync ? true : false
        
          return (
            <Box direction="row" width="150px">



            {isSynced && 
                  <Box direction="row" width="100%" gap="xsmall" align="center" pad={{ horizontal: 'small', vertical: 'xsmall' }} round="xsmall">
                    <FontAwesomeIcon
                    id={`cpoms-${datum.id}-yes`}
                    className={`cpoms-${datum.id}`}
                    icon={['fa', 'thumbs-up']}
                    color="#163567"
                    style={{ margin: '1px', opacity: 1 }}
                  />
                  <Text color="#163567" weight="bold">Synced</Text>
                </Box>
              }

            {isFailed && 
              <Box direction="row"  width="100%" gap="xsmall" align="center" pad={{ horizontal: 'small', vertical: 'xsmall' }} round="xsmall">

                <FontAwesomeIcon
                  id={`cpoms-${datum.id}-yes`}
                  className={`cpoms-${datum.id}`}
                  icon={['fa', 'exclamation-triangle']}
                  color="#FF0000"
                  style={{ margin: '1px', opacity: 1 }}
                />
                <Text color="#FF0000" weight="bold">Failed</Text>
              </Box>
              }
            
            {isEligibleToSync && <ActionButton small primary label="Upload" labelIcon={['fal', 'cloud-upload']} onClick={() => pushIncidentToCpoms(datum.id)} />}

            {unableToSync && 
              <Box direction="row" width="100%" gap="xsmall" align="center" pad={{ horizontal: 'small', vertical: 'xsmall' }} round="xsmall">
                <FontAwesomeIcon
                  className={`cpoms-${datum.id}`}
                  icon={['fal', 'unlink']}
                  color="#777"
                  style={ { margin: '1px', opacity: 1 }}
                />
                  <Text color="#777" weight="bold" hover={{ background: '#777' }}>Not&nbsp;Found</Text>
              </Box>}

        
            </Box>
          );

        },
      })
    }
    resultColumns.push({
      property: 'flag',
      header: <Text pad='none' margin='none' color='secondary' weight='800'>Flag</Text>,
      render: datum => {
        const setColour = async color => {
          await FormService.updateSubmission(apiToken, datum.id, {
            flag: color,
          });

          let elements = Array.from(
            document.getElementsByClassName(`flag-${datum.id}`),
          );
          for (let i = 0; i < elements.length; i++) {
            elements[i].style.opacity = 0.15;
          }
          document.getElementById(
            `flag-${datum.id}-${color}`,
          ).style.opacity = 1;

        };

        return (
          <Box direction="row" width="100%">
            <ActionButton plain onClick={() => setColour('none')}>
              <FontAwesomeIcon
                id={`flag-${datum.id}-none`}
                className={`flag-${datum.id}`}
                icon={['fa', 'flag']}
                color="#777"
                style={
                  !['red', 'green', 'yellow'].includes(datum.flag)
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
            <ActionButton plain onClick={() => setColour('green')}>
              <FontAwesomeIcon
                id={`flag-${datum.id}-green`}
                className={`flag-${datum.id}`}
                icon={['fa', 'flag']}
                color="#00FF00"
                style={
                  'green' === datum.flag
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
            <ActionButton plain onClick={() => setColour('yellow')}>
              <FontAwesomeIcon
                id={`flag-${datum.id}-yellow`}
                className={`flag-${datum.id}`}
                icon={['fa', 'flag']}
                color="#FFA500"
                style={
                  'yellow' === datum.flag
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
            <ActionButton plain onClick={() => setColour('red')}>
              <FontAwesomeIcon
                id={`flag-${datum.id}-red`}
                className={`flag-${datum.id}`}
                icon={['fa', 'flag']}
                color="#FF0000"
                style={
                  'red' === datum.flag
                    ? { margin: '1px', opacity: 1 }
                    : { margin: '1px', opacity: 0.15 }
                }
              />
            </ActionButton>
          </Box>
        );
      },
    })
    resultColumns.push({
      property: 'actions',
      header: <Text pad='none' margin='none' color='secondary' weight='800'>Actions</Text>,
      render: datum => (
        <>
          <Box direction="row" width="100%">
            {props?.type !== 'smartplan' && (
              <ActionButton
                onClick={() => {

                  if (datum?.subtype === 'highlevel') {
                    navigate(`/incident/high-level/${datum.userId}/edit/${datum.id}`);
                  } else {
                    navigate(`/incident/${datum.userId}/edit/${datum.id}`);
                  }
                  
                }}
                target="_self"
                plain
                children={
                  <Box pad="5px">
                    <FontAwesomeIcon icon={['fal', 'edit']} color="#ff8300" />
                  </Box>
                }
              />
            )}

            {datum.pdfUrl && (
              <>
                <ActionButton
                  target="_blank"
                  plain
                  href={datum.pdfUrl}
                  children={
                    <Box pad="5px">
                      <FontAwesomeIcon
                        icon={['fal', 'download']}
                        color="#ff8300"
                      />
                      {/* <Download color='primary' size='medium' disabled /> */}
                    </Box>
                  }
                />

                <ActionButton
                  plain
                  href={"/pdfviewer?url=" + encodeURIComponent(datum.pdfUrl)}
                  children={
                    <Box pad="5px">
                      <FontAwesomeIcon
                        icon={['fal', 'eye']}
                        color="#ff8300"
                      />
                      {/* <Download color='primary' size='medium' disabled /> */}
                    </Box>
                  }
                />

                {isServiceAdmin() && <ActionButton
                  target="_blank"
                  plain
                  onClick={() => {
                    deleteReport(datum.id);
                  }}
                  children={
                    <Box pad="5px">
                      <FontAwesomeIcon
                        icon={['fal', 'trash']}
                        color="#ff8300"
                      />
                    </Box>
                  }
                />}
              </>
            )}
          </Box>
        </>
      ),
    })



  if (loading) {
    return <Box direction='row' gap='medium' >
      <Box background='white' direction='column' gap='small' margin={{ top: 'small', bottom: 'large' }} border={{ color: 'light-4', side: 'right' }} pad='medium' flex='grow'>
        <PulseLoader color='#ff8300' size={15} margin={5} />
      </Box>
    </Box>
  }

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small' margin={{ bottom: 'large' }}>
      <Divider color='primary' />
      <Box
        gap='small'
        round='small'
      >        
        <DataTable
              columns={resultColumns}
              data={data}
              primaryKey="id"
              border={{ color: '#ddd' }}
              step={250}
              paginate={true}
              sort={sort}
              onSort={setSort}
            />
            {!data.length && <Text>There are no results to display.</Text>}
      </Box>
    </Box>
  )
}
export default Incidents
